import { RootState, store } from "@store";
import axios from "axios";
import { accessTokenStored } from "../store/token/TokenSlice";

// Criação da instância do Axios
const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 120000,
});

let isRefreshing = false;
let failedQueue: Array<{
  resolve: (value?: any) => void;
  reject: (reason?: any) => void;
}> = [];

function toError(err: unknown): Error {
  if (err instanceof Error) return err;
  return new Error(typeof err === "string" ? err : JSON.stringify(err));
}

const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach(({ resolve, reject }) => {
    if (error) {
      reject(toError(error));
    } else {
      resolve(token);
    }
  });
  failedQueue = [];
};

api.interceptors.request.use((config) => {
  const access_token = (store.getState() as RootState).tokenHandling.accessToken;
  config.headers.Authorization = `Bearer ${access_token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then(() => api(originalRequest))
          .catch((err) => Promise.reject(toError(err)));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const userManager = (window as any).userManager;
        if (userManager) {
          const user = await userManager.signinSilent();
          if (user?.access_token) {
            store.dispatch(accessTokenStored(user.access_token));
            processQueue(null, user.access_token);
            return api(originalRequest);
          }
        }
      } catch (refreshError) {
        processQueue(refreshError, null);
        localStorage.clear();
        window.location.href = "/";
        return Promise.reject(toError(refreshError));
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(toError(error));
  }
);

export default api;
